import axios from 'axios'
import createAuthRefreshInterceptor from 'axios-auth-refresh'
import { decamelizeKeysInterceptor } from './interceptors/request/decamelizeKeysInterceptor'
import { camelizeKeysInterceptor } from './interceptors/response/camelizeKeysInterceptor'
import { responseErrorInterceptor } from './interceptors/response/responseErrorInterceptor'
import { refreshTokenInterceptor } from './interceptors/refresh/refreshTokenInterceptor'
import injectBaseParamsDefault from './interceptors/request/injectBaseParamsDefault'
import { setNetworkFailures } from '../../state/slices/temporary_data_slice'
import { getStore } from '../../state/configure_store'
import { createNetworkRetryInterceptor } from './interceptors/response/networkRetryInterceptor'
import { addAxiosDebugInterceptors } from './interceptors/debug/debugLogInterceptor'
import { applyCurrentAuthorizationHeader } from './interceptors/request/applyCurrentAuthorizationHeader'

const source = process.env.REACT_APP_SOURCE || process.env.EXPO_PUBLIC_SOURCE
const isWeb = source === 'web'

const client = axios.create({
  timeout: 15000,
  headers: isWeb ? {} : { 'Cache-Control': 'no-store, no-cache', Pragma: 'no-cache' }
})

// Use retry client to prevent decamelize interceptor from decamelizing again which would deconstruct the object to a string.
const retryClient = axios.create({
  timeout: 15000,
  headers: isWeb ? {} : { 'Cache-Control': 'no-store, no-cache', Pragma: 'no-cache' }
})

addAxiosDebugInterceptors(client, 'client')
addAxiosDebugInterceptors(retryClient, 'auth-retry')

// Order at runtime: injectBaseData → injectBaseParams → decamelize (LIFO)
client.interceptors.request.use(decamelizeKeysInterceptor)
client.interceptors.request.use(injectBaseParamsDefault)

// Order at runtime: refreshToken → camelize → responseError (FIFO)
createAuthRefreshInterceptor(client, refreshTokenInterceptor, {
  statusCodes: [401],
  retryInstance: retryClient,
  onRetry: applyCurrentAuthorizationHeader
})

client.interceptors.response.use(
  camelizeKeysInterceptor,
  createNetworkRetryInterceptor(client)
)

client.interceptors.response.use(
  camelizeKeysInterceptor,
  responseErrorInterceptor
)

retryClient.interceptors.response.use(
  camelizeKeysInterceptor,
  responseErrorInterceptor
)

client.interceptors.response.use((response) => {
  // Reset network failures on successful response
  const store = getStore()

  store.dispatch(
    setNetworkFailures(
      0
    )
  )

  return response
})

export default client
